module.exports = __webpack_public_path__ + "img/icon_jszlgl.ece1258a.png";